export enum EnumRequestValueType {
  covenant = "Convênio",
  client = "Cliente",
}
